import React from 'react';
// import DashLoading from '../components/DashLoading';
// import { Spin } from 'antd';
//import Loading from '../assets/images/loading.gif';
import CustomSpin from './Ant/CustomSpin';

//const ImgLoading = <img style={{ width: 30, height: 30 }} alt="Loading" src={Loading} />
const { innerHeight } = window;

const Spinner = React.memo(() => <div style={{ height: innerHeight - 180 }} className="text-center sanjabSpin">
    {/* <Spin  indicator={ImgLoading} /> */}
    <div style={{
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
    }}>
        <CustomSpin />
        <span style={{ marginTop: 10, color: '#9aa1a9',fontSize:13 }}>در حال بارگذاری</span>
    </div>


</div>)

export default Spinner;
